import { StyledButton } from "./button.styles";
import { ButtonProps } from "./button.interface";
import { makeStyles } from "@material-ui/core";
import { LoadingIcon } from "../../icons";

const buttonStyles = makeStyles(() => ({
  loadingIcon: {
    marginRight: "10px",
  },
}));

export const Button = ({ children, loading, ...props }: ButtonProps) => {
  const classes = buttonStyles();
  return (
    <StyledButton {...props}>
      {loading && <LoadingIcon className={classes.loadingIcon} />}
      {children}
    </StyledButton>
  );
};

Button.displayName = "Button";
